import { render, staticRenderFns } from "./PaymentModal.vue?vue&type=template&id=2383f8d8&scoped=true"
import script from "./PaymentModal.vue?vue&type=script&lang=ts"
export * from "./PaymentModal.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PaymentModal.vue?vue&type=style&index=0&id=2383f8d8&prod&lang=stylus&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2383f8d8",
  null
  ,true
)

export default component.exports